function setFirstVisible(form: HTMLFormElement | null) {
    const others = form?.querySelectorAll('.focus-visible ~ .visible');
    others?.forEach((item: HTMLInputElement) => {
        return item.classList.remove('validate--first');
    });
    const first = form?.querySelector('.focus-visible ~ .visible');
    first?.classList.add('validate--first');
}

export function addVisible(element: HTMLInputElement, cls: string): void {
    element.classList.add(cls);
    element.parentElement?.querySelector<HTMLElement>(cls)?.classList.add('visible');
    setFirstVisible(element.form);
}

export function removeVisible(element: HTMLInputElement, ...cls: string[]): void {
    element.classList.remove(...cls);
    element.parentElement?.querySelectorAll<HTMLElement>(cls.join(','))?.forEach((item: HTMLElement) => {
        return item.classList.remove('visible');
    });
    setFirstVisible(element.form);
}
